<template>
	<page>
		<module>
			<view-list work-type="34" ref="view" selector :view-config="auth('b_assemble_viewmanage')">
				<template #search>
					<m-search ref="search">
						<m-search-item label="装配工单号">
							<c-input name="order_code"></c-input>
						</m-search-item>
						<m-search-item label="创建时间" colspan="2">
							<c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
						</m-search-item>
					</m-search>
				</template>

				<template #operate>
					<c-button color="main" v-if="auth('b_assemble_create')" v-lock="lock('b_assemble_create')" prepend-icon="tf-add" @click="editOrder()">创建装配工单</c-button>
					<c-button v-if="auth('b_assemble_export')" v-lock="lock('b_assemble_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<c-button v-if="auth('b_assemble_export')" v-lock="lock('b_assemble_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId(3)">按模板导出</c-button>
				</template>

				<template #batchOperate="{data}">
					<c-button v-if="auth('b_assemble_export')" v-lock="lock('b_assemble_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<c-button v-if="auth('b_assemble_export')" v-lock="lock('b_assemble_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId(3)">按模板导出</c-button>
					<c-button v-if="auth('b_assemble_print')" v-lock="lock('b_assemble_print')" prepend-icon="tf-print" @click="$refs.view.batchExportByTemplate()">打印</c-button>
				</template>

				<template #otherOperate>
					<c-button v-if="auth('b_assemble_log')" v-lock="lock('b_assemble_log')" prepend-icon="tf-operate-record" @click="$refs.view.loadWorkLogDetail()">操作记录</c-button>
				</template>

				<template #order_code="{data}">
					<c-link @click="globalDialog('assembleDetail', {props: {id: data.id}})">{{data.order_code}}</c-link>
				</template>

				<!--单据状态-->
				<template #order_state="{data}">
					<c-state dict="orderStateDic" tag :value="data.order_state"></c-state>
				</template>
				
				<!--生产进度%-->
				<template #work_progress="{data}">
					<c-progress :rate="[data.ok_count, data.plan_count]" :color="((data.ok_count/data.plan_count)>=1||data.plan_count==0) ?'green':'blue'"></c-progress>
				</template>

				<!--单据进度%-->
				<template #order_progress="{data}">
					<c-progress :rate="[data.work_end_count, data.work_all_count]" :color="((data.work_end_count/data.work_all_count)>=1||data.work_all_count==0) ?'green':'blue'"></c-progress>
				</template>
				
				<!--关联单据-->
				<template #ref_code="{data}">
					<order-link :type="data.ref_type" :id="data.ref_id" :code="data.ref_code"></order-link>
				</template>

				<c-table-column
					type="button"
					label="操作"
					width="175"
					button-limit="3"
				>
					<template #default="{data}">
						<c-table-button v-if="auth('b_assemble_edit')" v-lock="lock('b_assemble_edit')" icon="tf-edit" @click="editOrder(data)">编辑</c-table-button>
						<c-table-button icon="tf-detail" @click="globalDialog('assembleDetail', {props: {id: data.id}})">查看</c-table-button>
						<c-table-button v-if="auth('b_assemble_print')" v-lock="lock('b_assemble_print')" icon="tf-print" @click="$refs.view.exportByTemplate(data.id)">打印</c-table-button>
						<c-table-button v-if="auth('b_assemble_delete')" v-lock="lock('b_assemble_delete')" icon="tf-trash" @click="removeOrder(data)">删除</c-table-button>
					</template>
				</c-table-column>
			</view-list>
			<!--创建、编辑装配工单信息弹窗-->
			<assemble-edit ref="assembleEdit" @resolve="$refs.view.update()"></assemble-edit>
		</module>
	</page>
</template>

<script>
	import assembleEdit from '@/pages/production/assemble_edit.vue'
	import {mapState} from 'vuex'

	export default {
		components: {
			assembleEdit
		},
		
		data() {
			return {
			}
		},

		computed: {
			// 获取dictName选项数据
			...mapState(['orderStateDic'])
		},
		
		methods: {
			
			/******新建/编辑装配工单*******/
			editOrder(data) {
				this.$refs.assembleEdit.open(data);
			},
			
			/******删除装配工单************/
			removeOrder(data){
				this.$confirm({
					message:'确认删除装配工单【'+data.order_code+'】？删除后不可恢复',  // 提示内容,
					// buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/assemble/delete',
							data: {id:data.id},
							loading: true,
							success: data => {
								this.$message({
									message:'删除成功',  // 提示内容,
									type: 'success'
								});
								//刷新
								this.$refs.view.update();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>